import React from 'react';
import { Modal } from '../../../../../base/components/Modal';
import { __t } from '../../../../../base/utils/t';
import { Confirmation } from '../../../../components/Confirmation';
import { useAppDispatch, useAppSelector } from '../../../../../base/hooks';
import { workerAppActions } from '../../../../redux/slices/workerAppSlice';
import { ReactComponent as ConfirmPhoneIcon } from '../../../../assets/img/confirm-phone-icon.svg';
import { Button } from '../../../../../base/components/Button';
import { quickSignUpActions } from '../../../authorization/redux/slices/quickSignUpSlice';

import './styles.scss';
import { Loading } from '../../../../../base/enums';
import CircularProgress from '@mui/material/CircularProgress/CircularProgress';

interface Props {
    showModal: boolean;
    hideModalHandler: () => void;
}

export const VerifyPhoneModal = ({ showModal, hideModalHandler }: Props) => {
    const dispatch = useAppDispatch();
    const {
        fields: { phone, smsCode },
        errors,
    } = useAppSelector((state) => state.workerAppQuickSignUp);
    const isLoading = useAppSelector((state) => state.app.loading === Loading.VerificationCode);

    const verificationCodeChangeHandler = (value: unknown) => {
        dispatch(quickSignUpActions.setField({ id: 'smsCode', value }));
    };

    const submitResendCode = (recaptchaToken: string | null, callback: () => void) => {
        dispatch(workerAppActions.sendConfirmationCode(phone, recaptchaToken, callback));
    };

    const submitChangeConfirmationValue = (newValue: string, recaptchaToken: string | null, callback: () => void) => {
        dispatch(quickSignUpActions.submitChangeConfirmationValue(newValue, recaptchaToken, callback));
    };

    const successSignUpCallback = () => {
        window.location.reload();
    };

    const submitQuickSignUp = () => {
        dispatch(quickSignUpActions.submitQuickSignUp(successSignUpCallback));
    };

    return (
        <div className='quick-apply-phone-verification-modal'>
            <Modal
                visible={showModal}
                visibilityHandler={hideModalHandler}
                className='quick-apply-phone-verification-modal__modal'
                containerClassName='quick-apply-phone-verification-modal__container'
            >
                <ConfirmPhoneIcon className='quick-apply-phone-verification-modal__icon' />
                <h2 className='quick-apply-phone-verification-modal__title'>{__t('Подтвердите номер телефона')}</h2>
                <Confirmation
                    codeValue={smsCode || ''}
                    confirmationMethod='phone'
                    text={
                        <>
                            {__t('Введите код, который мы отправили в Viber/SMS на номер')}&nbsp;
                            <strong>{phone}</strong>
                        </>
                    }
                    codeErrors={errors?.smsCode}
                    changeConfirmationValueErrors={errors?.phone}
                    updateModalText={__t('Мы отправим код для подтверждения')}
                    verificationCodeChangeHandler={verificationCodeChangeHandler}
                    submitResendCode={submitResendCode}
                    submitChangeConfirmationValue={submitChangeConfirmationValue}
                    editVerificationMethodValueHandler={hideModalHandler}
                />
                <Button
                    className='quick-apply-phone-verification-modal__button'
                    disabled={isLoading}
                    onClick={submitQuickSignUp}
                >
                    {isLoading ? (
                        <CircularProgress
                            style={{ color: '#fff' }}
                            size={18}
                            className='code-confirmation__update-modal-button-loading'
                        />
                    ) : (
                        __t('Подтвердить')
                    )}
                </Button>
            </Modal>
        </div>
    );
};
